import React, { Suspense, lazy, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFetch } from 'utils/hooks';
import { GET_EVENT, LOCATION } from 'constants.js';
import { useWindowSize } from 'utils/hooks';
import { convertEvent } from 'utils/itemUtil';
import { useStateValue } from 'context/store';
import {
  setCurrency,
  clearPrice,
  setTickets,
  setSlug
} from 'context/eventItem/actions';
import { useLocation } from 'react-router-dom';
import ModalComponent from 'components/modal2';
import Button from 'components/button';

const MobilePage = lazy(() =>
  import(/* webpackChunkName: "MobilePage" */ './MobilePage')
);

const DesktopPage = lazy(() =>
  import(/* webpackChunkName: "DesktopPage" */ './DesktopPage')
);

function EventItemPage(props) {
  const { slug } = useParams();
  const { width } = useWindowSize();
  const { dispatch } = useStateValue();
  const [res, { loading, error }] = useFetch(
    {},
    `${GET_EVENT}/${slug}/`,
    { method: 'GET' },
    'event'
  );

  useFetch(
    {},
    LOCATION,
    {
      method: 'get'
    },
    'itemPageLocation'
  );

  const response = convertEvent(res);

  useEffect(() => {
    dispatch(setCurrency(response.currency));
  }, [dispatch, response.currency]);

  useEffect(() => {
    dispatch(setTickets(response.tickets));
    dispatch(clearPrice());
    dispatch(setSlug(res.slug));
    sessionStorage.setItem('terms', res.event_terms_and_conditions);
    // eslint-disable-next-line
  }, [res.slug]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const terms = searchParams.get('terms');

  if (width === undefined || width === null) {
    // Wait for the window size
    return <div>{null}</div>;
  }

  if (width <= 992) {
    return (
      <Suspense fallback={<p>{null}</p>}>
        <MobilePage error={error} res={response} loading={loading} />
        {terms && (
          <ModalComponent
            modalIsOpen={terms}
            modalTitle="Terms and Conditions"
            closeThisModal={() => {
              props.history.push(`/event/${res.slug}`);
            }}
            width={width < 768 ? '100%' : '50%'}
          >
            <h4>Terms and Conditions</h4>
            <div
              dangerouslySetInnerHTML={{
                __html: res.event_terms_and_conditions
              }}
            ></div>

            <div
              className="modal-footer"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginTop: 20,
                gap: 20
              }}
            >
              <Button
                color="light"
                onClick={() => {
                  props.history.push(`/event/${res.slug}`);
                }}
                style={{
                  width: '100%',
                  maxWidth: 200
                }}
              >
                Cancel
              </Button>
            </div>
          </ModalComponent>
        )}
      </Suspense>
    );
  }
  // Desktop Page
  if (width > 992) {
    return (
      <Suspense fallback={<p>{null}</p>}>
        <DesktopPage error={error} res={response} loading={loading} />
        {terms && (
          <ModalComponent
            modalIsOpen={terms}
            modalTitle="Terms and Conditions"
            closeThisModal={() => {
              props.history.push(`/event/${res.slug}`);
            }}
            width={width < 768 ? '100%' : '50%'}
          >
            <h4>Terms and Conditions</h4>
            <div
              dangerouslySetInnerHTML={{
                __html: res.event_terms_and_conditions
              }}
            ></div>

            <div
              className="modal-footer"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginTop: 20,
                gap: 20
              }}
            >
              <Button
                color="light"
                onClick={() => {
                  props.history.push(`/event/${res.slug}`);
                }}
                style={{
                  width: '100%',
                  maxWidth: 200
                }}
              >
                Cancel
              </Button>
            </div>
          </ModalComponent>
        )}
      </Suspense>
    );
  }

  return null;
}

export default EventItemPage;
